import { render, staticRenderFns } from "./basic-traveler-form.vue?vue&type=template&id=76805e1d&scoped=true&"
import script from "./basic-traveler-form.vue?vue&type=script&lang=js&"
export * from "./basic-traveler-form.vue?vue&type=script&lang=js&"
import style0 from "./basic-traveler-form.vue?vue&type=style&index=0&id=76805e1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76805e1d",
  null
  
)

export default component.exports